export const HOUSES_COLUMNS = [
    {
        header: 'Item',
        key: 'images',
        type: 'image',
    },
    {
        header: 'Address',
        key: 'address',
        type: 'title',
    },
    {
        header: 'Owner',
        key: 'owner_name',
        type: 'text',
    },
    {
        header: 'Block',
        key: 'block',
        type: 'text',
    },
    {
        header: 'Lot',
        key: 'lot',
        type: 'text',
    },
    {
        header: 'Class',
        key: 'type_of_property',
        type: 'light',
    },
    {
        header: 'Recent Activity',
        key: 'recent_activity',
        type: 'text',
    },
    {
        header: 'Token ID',
        key: 'hash',
        type: 'text',
    },
    {
        header: 'Status',
        key: 'is_verified',
        type: 'tag',
    },
    {
        header: '',
        key: 'feature',
        type: 'feature',
        class: 'xs',
    },
];
